import type { Products } from "../types"

export const products: Products = new Map([
  [
    "euler-base",
    {
      name: "Euler Base",
      description:
        "A market tailored to borrowing stable assets against blue chip crypto assets. Governed by Euler DAO.",
      entity: ["euler-dao", "gauntlet"],
      url: "",
      vaults: [
        "0x859160DB5841E5cfB8D3f144C6b3381A85A4b410",
        "0x7b181d6509DEabfbd1A23aF1E65fD46E89572609",
        "0x358f25F82644eaBb441d0df4AF8746614fb9ea49",
        "0xd4A805261B28f375fc9c3d89EcD2C952Cd130d14",
        "0xa487f940D6f40D7304CD4e62751220f97124BeC9",
        "0x8b70a855B057cA85F38Ebb2a7399D9FE0BDC1046",
        "0x0A1a3b5f2041F33522C4efc754a7D096f880eE16",
        "0x9ECD9fbbdA32b81dee51AdAed28c5C5039c87117",
        "0x882018411Bc4A020A879CEE183441fC9fa5D7f8B",
        "0x3f0d3Fd87A42BDaa3dfCC13ADA42eA922e638a7A",
        "0x5Fe2DE3E565a6a501a4Ec44AAB8664b1D674ac25",
        "0x556d518FDFDCC4027A3A1388699c5E11AC201D8b",
        "0x65cFEF3Efbc5586f0c05299343b8BeFb3fF5d81a",
        "0x841C92bfF53c81cDdb8ad557096B30C93fddb394",
        "0x72c8B07E5aD9F2DcC3cA2c05927c31ddCf2Ffe9A",
      ],
    },
  ],
  [
    "apostro-resolv",
    {
      name: "Apostro Resolv",
      entity: "apostro",
      vaults: [
        "0xC063C3b3625DF5F362F60f35B0bcd98e0fa650fb",
        "0x29Dbce367F5157B924Af5093617bb128477D7A5C",
        "0x1E2F1e8A97E96a2FDD6A8Da427603Ed1c8b3847F",
        "0x3F131Ac9D408926a8B36C1e03ce105f44DCD26Af",
        "0x5ce15fC058E762A6F9722fC6521A0c0F5eECD9BA",
        "0x34ABB4501419b1E5f836567C58300c861164101A",
        "0xEdCc195Ca09c9FCC1DD30b152C0b82045Ff2F91f",
        "0x596dBb33131fa2991cf5651cB57e4b15682C7F93",
      ],
    },
  ],
  [
    "re7-labs-basic",
    {
      name: "Re7 Labs Cluster",
      entity: "re7-labs",
      vaults: [
        "0xaa40BD076d80F3bA18F7E09ddb1E9962c00C1047",
        "0x8300dE22B2c6c675C056fC75855423Ec7dC90F52",
        "0x5103f6C0D0aA0616C5DbAB52EcA82110322c9821",
        "0x12ebafd758c9532b02Dd57189c12A140D17D2b9E",
        "0x28CF85d1249Eb8a2988699Fd72E3B1CafAEfd17B",
        "0xCf033218B983d286fb3082b34c597bb408C55c0C",
        "0x9E77a118a136EEe9ec1be1D34a2C89FB0e953545",
        "0x4790BCbF34e2be50475364DACa01908eBa35e0ca",
        "0xbc02160f3AfdBb2fA77154b552504d7D01Bfdc2F",
      ],
    },
  ],
  [
    "frontier-yo-yobtc",
    {
      name: "Frontier YO yoBTC Market",
      description:
        "An isolated market dedicated to the YO yoBTC ecosystem. Frontier markets are not actively risk managed. Please ensure you are comfortable with the risk exposure before lending.",
      entity: ["euler-dao", "gauntlet"],
      url: "https://forum.euler.finance/t/community-requests-for-frontier-markets/1433/3",
      vaults: [
        "0xe72eA97aAF905c5f10040f78887cc8dE8eAec7E4",
        "0xFab9aF50F7A1Cfe201CAE1c15fCFdDaE7705ccD3",
      ],
      isGovernanceLimited: true,
    },
  ],
  [
    "frontier-yo-yoeth",
    {
      name: "Frontier YO yoETH Market",
      description:
        "An isolated market dedicated to the YO yoETH ecosystem. Frontier markets are not actively risk managed. Please ensure you are comfortable with the risk exposure before lending.",
      entity: ["euler-dao", "gauntlet"],
      url: "https://forum.euler.finance/t/community-requests-for-frontier-markets/1433/3",
      vaults: [
        "0x774C08F8e78C47046d325C0331788954C35DF10a",
        "0xdbDC9c3EdBD401109c83b333c16A0251806b3330",
        "0x38Df63F1986B80578B7357BCda3D4f71F129AfFf",
      ],
      isGovernanceLimited: true,
    },
  ],
  [
    "frontier-yo-yousd",
    {
      name: "Frontier YO yoUSD Market",
      description:
        "An isolated market dedicated to the YO yoUSD ecosystem. Frontier markets are not actively risk managed. Please ensure you are comfortable with the risk exposure before lending.",
      entity: ["euler-dao", "gauntlet"],
      url: "https://forum.euler.finance/t/community-requests-for-frontier-markets/1433/3",
      vaults: [
        "0x085178078796Da17B191f9081b5E2fCCc79A7eE7",
        "0x990d616ca6E7192625d1B7C41Fb67b5758DF7CF2",
        "0x24D633664Aea3F551B2Fa34fA66Dd1BA52a33933",
      ],
      isGovernanceLimited: true,
    },
  ],
  [
    "alterscope-lrt",
    {
      name: "Alterscope LRT",
      description: "Vaults designed for advanced liquid restaking strategies.",
      entity: "alterscope",
      vaults: [
        "0xf4480166d66CFb9c5E12C843A8F844F512989289",
        "0xF3BB6b0a9bEAF9240D7F4a91341d5Df6bF37cAea",
      ],
    },
  ],
  [
    "edge-capital-core-cluster",
    {
      name: "Edge UltraYield Cluster",
      entity: "edge-capital",
      vaults: [
        "0x611745c9107d0197f161556691c5129fD9B898D1",
        "0x614bD506051a8CCfCBc57C34aEdcf6CaffCd5d17",
        "0x1Fd3A242a549D595431442F898FDbb374F15B885",
        "0x85114A78c512872Df273CA12f35FBE4Cf0749616",
        "0xBC46393223990D024fcb2b0Ff2f5A4cd52602ea2",
        "0xD7c286712bd46aa8acBec4EA99d3018b32Edb190",
        "0x78d6A3BC9d41B7C6Fd52FF2E85a2dF6d1F4F9B3a",
        "0xA67A95971b8D010c16de4B33259D1c574d256121",
      ],
    },
  ],
  [
    "alphagrowth-base",
    {
      name: "AlphaGrowth Base Vaults",
      description:
        "A market tailored to borrowing against blue chip crypto assets. Governed by AlphaGrowth.",
      entity: ["alphagrowth"],
      url: "https://alphagrowth.io/",
      vaults: [
        "0x81744B5B5527852832F2dd3554C191d3B1342108",
        "0x4C1aeda9B43EfcF1da1d1755b18802aAbe90f61E",
      ],
    },
  ],
])
